export enum SocialShareWidgetComponentIds {
  TopContainer = '#box1',
  WhatsApp = '#buttonwhatsapp',
  Facebook = '#buttonfacebook',
  Twitter = '#buttontwitter',
  Pinterest = '#buttonpintrest',
}

export const defaultSocialShareEnglishLabels = ['Facebook', 'Twitter', 'Pinterest', 'Whatsapp'];
